/** Drive list item status */
export enum DriveListItemStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

/**
 * Max concurrent nested-subfolder resolutions (find-or-create) per drag-and-drop batch.
 * Bounds the request burst for a drop with many distinct top-level dropped folders.
 */
export const kMaxConcurrentNestedFolderResolutions = 5

/**
 * Max folder nesting depth accepted from a single dropped directory. The backend enforces no
 * depth limit on folder creation, so without this a deeply nested dropped directory would walk
 * an unbounded chain of sequential find-or-create requests (see getOrCreateFolderPathId).
 */
export const kMaxDroppedFolderDepth = 20

/**
 * Shown when a drop produces nothing to upload — an empty folder, or one holding only OS metadata
 * files. Nothing is queued in that case, so there is no upload row to carry an inline message and
 * the drop would otherwise look like it silently did nothing. Deliberately does not explain the
 * cause: "system files" is jargon most users don't have, and the empty-folder case is self-evident.
 */
export const kNoUploadableFilesMessage = 'No uploadable files found.'
